export const BREAKPOINTS = {
    mobile_max: 1280,
};
